import React from 'react';
import PropTypes from 'prop-types';

import { Wrap, Background, Icon, Name, SubcategoryLink } from './styled';

class Item extends React.PureComponent {
    render() {
        const { name, iconPath, isActiveCategory, permalink, onClick, subcategories } = this.props;
        return (
            <>
                <Wrap
                    isActiveCategory={isActiveCategory}
                    to={permalink}
                    onClick={onClick}
                    type="catalog-link"
                >
                    <Background isActiveCategory={isActiveCategory} />
                    {iconPath && <Icon iconPath={iconPath} isActiveCategory={isActiveCategory} />}
                    <Name isActiveCategory={isActiveCategory}>{name}</Name>
                </Wrap>
                {subcategories &&
                    subcategories.map((subcategory) => (
                        <SubcategoryLink key={subcategory.id} to={subcategory.permalink}>
                            {subcategory.name}
                        </SubcategoryLink>
                    ))}
            </>
        );
    }
}

Item.propTypes = {
    name: PropTypes.string,
    iconPath: PropTypes.string,
    isActiveCategory: PropTypes.bool,
    permalink: PropTypes.string,
    onClick: PropTypes.func,
};

Item.defaultProps = {
    name: '',
    iconPath: '',
    isActiveCategory: false,
    permalink: '',
    onClick: () => {},
};

export default Item;
